import React, {useContext, useEffect, useState} from 'react'
import {SessionContext} from 'Utils/sessions';
import s from './styles/Dashboard.module.scss'
import SideBar from 'Components/Nav/SideBar';
import {setSessionCookie} from "../Utils/sessions";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import {AdminApi} from "../Api/AdminApi";
import {Tab, Tabs} from "react-bootstrap";

const SUPPORT_CASE_STATUSES = ['All', 'Assigned', 'Attention Needed', 'Awaiting Reply', 'Closed']

const SupportDashboard = () => {
    const {session} =  useContext(SessionContext);
    const [supportPageData, setSupportPageData] = useState(null);
    const [supportCases, setSupportCases] = useState([])
    const tableHeaders = ['Case ID', 'Subject', 'Message', 'Email', 'User ID', 'Last Updated', 'Date Initiated']
    const [filerOpen, setFilterOpen] = useState(false)
    const [topic, setTopic] = useState('')
    const [tab, setTab] = useState('All')

    function toggleFilter() {
        setFilterOpen(!filerOpen)
    }

    function updateTopic(e) {
        setTopic(e?.target?.value.toUpperCase().replaceAll(' ', '_'))
        setFilterOpen(false)
    }

    useEffect(() => {
        AdminApi.User.getAdminPageSupportData({}, session.jwt).then(res => {
            setSupportPageData(res.data);
        }).catch(error => {
            if (error.message?.includes( '404')) {
                setSessionCookie({})
                window.location.href = window.location.hostname
            }
        })
    }, [session.jwt])

    return <div>
        <SideBar session={session} title={"Support"}>
            <div className={s.adminDashboard}>
                <main className={s.dataSection}>
                    <div className={s.dataTableContainer}>
                        <h3 className='heading'>Showing {tab === 'All' ? supportPageData?.supportCases?.length ?? 0 : supportCases?.length ?? 0} support cases</h3>
                        <div className={s.dataTableContainer}>
                            <Tabs className='mb-4 '
                                  activeKey={tab}
                                  onSelect={(k) => {
                                      setSupportCases(supportPageData.supportCases?.filter(supportCase => {
                                          if (k.toLowerCase() === 'all') {
                                              return true
                                          }

                                          return supportCase.status?.toLowerCase() === k.toLowerCase().replace(" ", "_")
                                      }))
                                      setTab(k)
                                  }}>
                                <Tab eventKey="All" title={<span className='d-flex align-items-center'>All</span>}>
                                    <SupportCaseTable headers={tableHeaders} data={supportPageData?.supportCases ?? [{}]}/>
                                </Tab>
                                <Tab eventKey="New" title={<span className='d-flex align-items-center'>New</span>}>
                                    <SupportCaseTable headers={tableHeaders} data={supportCases}/>
                                </Tab>
                                <Tab eventKey="Assigned" title={<span className='d-flex align-items-center'>Assigned</span>}>
                                    <SupportCaseTable headers={tableHeaders} data={supportCases}/>
                                </Tab>
                                <Tab eventKey="Attention Needed" title={<span className='d-flex align-items-center'>Attention Needed</span>}>
                                    <SupportCaseTable headers={tableHeaders} data={supportCases}/>
                                </Tab>
                                <Tab eventKey="Awaiting Reply" title={<span className='d-flex align-items-center'>Awaiting Reply</span>}>
                                    <SupportCaseTable headers={tableHeaders} data={supportCases}/>
                                </Tab>
                                <Tab eventKey="Closed" title={<span className='d-flex align-items-center'>Closed</span>}>
                                    <SupportCaseTable headers={tableHeaders} data={supportCases}/>
                                </Tab>
                            </Tabs>
                        </div>
                    </div>
                </main>
                <aside className={s.filterSection}>
                    <Card className={s.filterCard}>
                        <Card.Title className={s.filterCardHeader}>
                            <div className={s.filterCardTitle}>Filter Support Cases</div>
                            <div className={s.filterCardFilterToggle}>
                                <Button className={`btnLink`}
                                        onClick={toggleFilter}>{filerOpen ? 'Close' : 'Edit'}</Button>
                            </div>
                        </Card.Title>
                        <div className={s.mobile}>
                            {filerOpen &&
                                <>
                                    <Card.Body className={'my-0'}>
                                        <Button className={`${s.topicButton} ${topic === '' ? s.active : ''}`}
                                                onClick={updateTopic} value={''}>All Cases</Button>
                                        {SUPPORT_CASE_STATUSES.map((caseStatus, idx) =>
                                            <Button key={idx}
                                                    className={`${s.topicButton} ${topic === caseStatus.trim().toLowerCase().replaceAll(' ', '-') ? s.active : ''}`}
                                                    onClick={updateTopic}
                                                    value={caseStatus.trim().toLowerCase().replaceAll(' ', '-')}>{caseStatus.trim()}</Button>
                                        )}
                                    </Card.Body>
                                </>
                            }
                        </div>
                        <div className={s.desktop}>
                            <Card.Body className={'my-1'}>
                                <Button className={`${s.topicButton} ${topic === '' ? s.active : ''}`}
                                        onClick={updateTopic} value={''}>All topics</Button>
                                {[].map((caseStatus, idx) =>
                                    <Button key={idx}
                                            className={`${s.topicButton} ${topic === blogTopiccaseStatus.trim().toLowerCase().replaceAll(' ', '-') ? s.active : ''}`}
                                            onClick={updateTopic}
                                            value={caseStatus.trim().toLowerCase().replaceAll(' ', '-')}>{caseStatus.trim()}</Button>
                                )}
                            </Card.Body>
                        </div>
                    </Card>
                </aside>
            </div>
        </SideBar>
    </div>
}


const SupportCaseTable = ({headers, data}) => {
    return (
        <table className={s.dataTable}>
            <thead className={s.dataTableHeader}>
            <tr>
                {headers.map((header) => (
                    <th key={header} scope="col">
                        {header}
                    </th>
                ))}
            </tr>
            </thead>
            <tbody>
            {(data.length > 0 ? data : [{}]).toSorted((a, b) => (b.lastUpdated || b.timestamp) - (a.lastUpdated || a.timestamp)).map((row) => (
                <tr key={row.caseId} className={s.dataTableEntry}>
                    <td className={'py-4'}>
                        <button>
                            {row.caseId}
                        </button>
                    </td>
                    <td className={'px-6 py-4'}>
                        {row.subject}
                    </td>
                    <td className={'px-6 py-4'}>
                        {row.message}
                    </td>
                    <td className={'px-6 py-4'}>
                        {row.email}
                    </td>
                    <td className={'px-6 py-4'}>
                        {row.userId}
                    </td>
                    <td className={'px-6 py-4'}>
                        {new Date(row.lastUpdated || row.timestamp).toLocaleDateString()} at {new Date(row.lastUpdated || row.timestamp).toLocaleTimeString()}
                    </td>
                    <td className={'px-6 py-4'}>
                        {new Date(row.dateInitiated).toLocaleDateString()} at {new Date(row.dateInitiated).toLocaleTimeString()}
                    </td>
                </tr>
            ))}
            </tbody>
        </table>
    );
};


export default (SupportDashboard);
